import { Component } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';


@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.css']
})
export class DashboardComponent {

  constructor(private translate: TranslateService) {
    this.check();
  }

  check() {
    if (localStorage.getItem('lang') === null) {
      this.translate.setDefaultLang('en');
      localStorage.setItem('lang', 'en');
    } else if (localStorage.getItem('lang') === 'ru') {
      this.translate.setDefaultLang('ru');
    } else if (localStorage.getItem('lang') === 'en') {
      this.translate.setDefaultLang('en');
    } else if (localStorage.getItem('lang') === 'ch') {
      this.translate.setDefaultLang('ch');
    }
    else if (localStorage.getItem('lang') === 'bd') {
      this.translate.setDefaultLang('bd');
    }
  }

}



// WEBPACK FOOTER //
// C:/work/internal-frontend/src/app/dashboard/dashboard.component.ts